import { debounce } from '../utilities'
import { AJAX_URL, LOADING_CLASS } from '../utilities/constants'

export default class {
  constructor(el) {
    const formEl = el.querySelector('.js-filterForm')
    const targetEl = el.querySelector('.js-filterTarget')

    if (!formEl || !targetEl) {
      return
    }

    async function filterPosts() {
      try {
        formEl.classList.add(LOADING_CLASS)

        const formData = new FormData(formEl)

        const result = await fetch(AJAX_URL, {
          method: 'POST',
          body: formData,
        })

        const data = await result.json()

        if (data.html) {
          targetEl.innerHTML = data.html
        }
      } catch (error) {
        console.error(error)
      } finally {
        formEl.classList.remove(LOADING_CLASS)
      }
    }

    formEl.addEventListener(
      'change',
      debounce((event) => {
        event.preventDefault()

        filterPosts()

        return false
      }, 300)
    )
  }
}
